import { defineComponent, computed, ref, watch, getCurrentInstance } from "vue";
import Drawer from "@pt/views/pt-entry/components/drawer/index.vue";
import DetailTab from "./detail-tab.vue";
import HistoryTab from "./history-tab.vue";
import ProductDialog from "@pt/views/pt-entry/components/product-dialog/index.vue";
export default defineComponent({
    components: {
        Drawer: Drawer,
        DetailTab: DetailTab,
        HistoryTab: HistoryTab,
        ProductDialog: ProductDialog
    },
    props: {
        handlePreview: [
            Function
        ]
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var changeDialog = function changeDialog(value) {
            productDialogVisible.value = value;
        };
        var createProductToEdit = function createProductToEdit(row) {
            var _$ref;
            (_$ref = detailTabRef.value) === null || _$ref === void 0 ? void 0 : _$ref.handleSelectedProduct(row);
        };
        var updateSuccess = function updateSuccess(page) {
            emit("update-success", page);
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var detailTabRef = ref();
        var activeName = ref("detail");
        var productDialogVisible = ref(false);
        var detailDialog = computed(function() {
            return store.state.creative.detail.detailDialog;
        });
        watch(function() {
            return store.state.creative.detail.detailDialog.visible;
        }, function() {
            activeName.value = "detail";
        }, {
            immediate: true
        });
        return {
            detailTabRef: detailTabRef,
            detailDialog: detailDialog,
            activeName: activeName,
            productDialogVisible: productDialogVisible,
            changeDialog: changeDialog,
            createProductToEdit: createProductToEdit,
            updateSuccess: updateSuccess
        };
    }
});
